import { ModuleFE_FAQ } from "./ModuleFE_FAQ.js";
export const ModulePackFE_FAQDB = [ModuleFE_FAQ];
//# sourceMappingURL=module-pack.js.map